<template>
    <div class="content" >
        <!-- <div class="box"> -->
            <div class="coast-icon box" v-if="showCoast" @click="changePull">
                <img :src="require('@/assets/images/logo.png')" alt="">
            </div>
            <div :class="['list-icon', 'animate__animated', 'box',showCoast === true?'animate__slideInRight' : 'animate__slideInLeft']">
                <i class='iconfont icon-shuangzuojiantou- narrow' @click="changePull" v-if="!showCoast"></i>
                <ul class="option-box" >   
                <li  v-for="(item,idx) in typeList" :class="{'selected':selectIdx === idx }" :key="item.id" @click="currentSelect(item,idx)" >
                    <i :class="['iconfont','icon',`icon-${item.icon}`]"></i>
                    <span>{{ item.title }}</span>
                </li>
                </ul>
            </div>
        <!-- </div> -->
        <keep-alive>
        <component :is="typeList[selectIdx].com"></component> 
        </keep-alive>            
    </div> 
</template>

<script>
import BrandValue from '@/pages/brand/BrandValue.vue'
import HouseSavor from '@/pages/house/HouseSavor.vue'
import SandBox from '@/pages/sand/SandBox.vue'
export default {
    name: "KrpanoView",
    components: {
    BrandValue,
    HouseSavor,
    SandBox
    },
    data(){
        return {
            typeList:[
                {name:'scene_1', title:'区域沙盘', icon:'quyu',scene_id:1,com:'SandBox'},
                {title:'品牌价值', icon:'zuanshi_o', com:'BrandValue'},
                {title:'户型鉴赏', icon:'fl-huxing', com:'HouseSavor'}
            ],
            selectIdx:0,
            showCoast:false,
            showModel:false,
            isShow: false,
            
        }

    },
    methods:{

      changePull(){
      this.showCoast = !this.showCoast

      },
      currentSelect(item,idx){
      this.selectIdx = idx
      }
    }

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/font_chooseList/iconfont.css';
@import 'animate.css';

.box {
  position: absolute;
  left: .5rem;
  bottom: .8rem;
  z-index:99;
  color:#fff;
  font-size: 12px;
}
  .coast-icon {
    overflow: hidden;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    width:2.8rem;
    height:2.8rem;
    border-radius: 50%;
    background-color: rgba(0,0,0,0.7);
    img{
      width:80%;
      height:80%;
      border-radius: 50%;     
    }

  }
  .animate__slideInLeft {
    animation-name: sliderL-width;
  }
  @keyframes sliderL-width {
    0% {
        max-width: 0;
    }
    100%  {
        max-width: 15rem;
    }
    
  }
    .animate__slideInRight {
    animation-name: sliderR-width;
  }
  @keyframes sliderR-width {
    0% {
        max-width: 15rem;
    }
    100%  {
        max-width: 0;
    }
    
  }
  .list-icon {
    overflow: hidden;
    display: flex;
    background-color: rgba(0,0,0,0.7);
    border-radius: 2.5rem;
    padding-left: 1.9rem;
    padding-right: .9rem;
  .narrow {
    position: absolute;
    top: 0.9rem;
    left: 0.5rem;
  }
  .option-box {
    display: flex;
    padding-left: .3rem;
    li {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 4rem;
      height:2.8rem;
      .icon {
        font-size: 1.2rem;
      }

    }
    .selected {
      color:orange;
    }
  }

}




</style>